// src/ids/update-user-id/update-user-id.ts
import { updateCurrentContext } from "@youversion/analytics-core/dist/contexts/update-current-context/update-current-context";
function updateUserId(authData, callback) {
  var _a;
  let userId = null;
  if (typeof authData === "string") {
    try {
      const parsedAuthData = JSON.parse(authData);
      userId = typeof (parsedAuthData == null ? void 0 : parsedAuthData.id) === "number" ? parsedAuthData.id : null;
    } catch (error) {
      if (error instanceof Error && ((_a = window.yvaDatastore) == null ? void 0 : _a.config.debug)) {
        console.error(`Error setting user id:`, error.message);
      }
    }
  } else {
    userId = authData.id;
  }
  if (userId) {
    updateCurrentContext({ user_id: userId }).then(callback);
  } else if (callback) {
    callback();
  }
}

export {
  updateUserId
};
